import { Kid } from '../types/todo.types';

// Kids array with their avatars and colors
export const kids: Kid[] = [
  { name: 'Emma', avatar: '👧🏻', color: 'bg-pink-100 border-pink-400', textColor: 'text-pink-700' },
  { name: 'Erica', avatar: '👧🏻', color: 'bg-purple-100 border-purple-400', textColor: 'text-purple-700' },
  { name: 'Elly', avatar: '👧🏻', color: 'bg-blue-100 border-blue-400', textColor: 'text-blue-700' },
  { name: 'Emilia', avatar: '👧🏻', color: 'bg-green-100 border-green-400', textColor: 'text-green-700' }
];
